<template>
  <div class="map-page">
    <!-- 顶部资讯条 -->
    <RibbonBar />
    <!-- 顶部导航栏 -->
    <NavHeader :selected-nav="selectedNav" @nav-click="handleNavClick" @nav-click-4="handleRoute" />
    <img class="nhj-img" src="https://lbs-nfncb.nfncb.cn/gzmap/img/loading.png" alt="">
     <!-- 还原地图按钮 -->
     <div class="reset-map-btn" @click="resetMapToMaxZoom">
        <!-- <span class="reset-icon">⌂</span> -->
      </div>
    <!-- 地图容器 -->
    <div class="map-container" @touchmove.prevent>
     
      <tlbs-map
        ref="tlbsMap"
        api-key="TOWBZ-VKCK3-WDJ33-RSQE6-Z65I6-5VBXF"
        :center="center"
        :zoom="zoom"
        :control="mapControl"
        :options="mapOptions"
        @ready="onMapReady"
        @map_inited="onMapInited"
        :maxZoom="15"
        :minZoom="8"
        class="map-wrapper"
      >
        <!-- 点聚合组件 -->
        <tlbs-marker-cluster
          ref="markerClusterRef"
          :geometries="geometries"
          :options="{
            zIndex: 1
          }"
          :enable-default-style="false"
          @clusterchange="clusterChange"
        />
        
        <!-- 聚合点 -->
        <div
          v-for="(item, index) in aggregationPoints"
          :key="index"
        >
          <tlbs-dom-overlay
            :position="item.center"
            :offset="offset"
            @touchstart.native.stop="domoOverlayClick(item, $event)"
          >
            <div
              class="polymerization"
              :style="{
                'line-height': item['line-height']
              }"
              @touchstart.stop.prevent="domoOverlayClick(item, $event)"
              @click.stop.prevent="domoOverlayClick(item, $event)"
            >
              <span class="cluster-count">{{ item.content }}</span>
            </div>
          </tlbs-dom-overlay>
        </div>
        
        <!-- 分散点 -->
        <div
          v-for="(item, index) in scatteredPoints"
          :key="`scatter-${index}`"
        >
          <tlbs-dom-overlay
            :position="item.center"
          >
            <div class="point-container">
              <div
                class="point-logo"
                :class="{ 'point-disabled': item.properties && item.properties.is_seasonal == 0 }"
                @touchstart.stop.prevent="openDetail(item)"
                @click.stop.prevent="openDetail(item)"
              >
                <img :src="getMarkerIcon(item)" alt="marker" />
              </div>
              <div class="point-name">{{ getPointName(item) }}</div>
            </div>
          </tlbs-dom-overlay>
        </div>
      </tlbs-map>
    </div>
    <!-- 右下角分类选择菜单 -->
    <CategoryMenu 
      :selected-nav="selectedNav" 
      :selected-category="selectedCategory"
      @category-select="handleCategorySelect"
    />
    
    <!-- 底部搜索和功能按钮 -->
    <div class="bottom-actions">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <div 
          class="search-input"
          @click="onSearchBtnClick"
        >探索更多精彩内容</div>
        <button class="search-btn" @click="onSearchBtnClick">
        </button>
      </div>
      
      <!-- 功能按钮 -->
      <!-- <div class="action-buttons">
        <img 
          class="action-btn route-btn" 
          :src="lineIcon" 
          alt="旅游路线" 
          @click="handleRoute"
        />
        <img 
          class="action-btn news-btn" 
          :src="newsIcon" 
          alt="新闻资讯" 
          @click="handleNews"
        />
      </div> -->
    </div>
    
    <!-- 搜索弹窗 -->
    <SearchPopup 
      v-model="showSearchPopup"
      @result-click="handleResultClick"
    />
    
    <!-- 店铺列表弹窗（同一位置多个点位） -->
    <ShopListPopup 
      v-model="showShopListPopup"
      :shop-list="sameLocationShops"
      @shop-click="handleShopFromListClick"
    />
    
    <!-- 店铺详情弹窗 -->
    <ShopDetailPopup 
      v-model="showShopDetailPopup"
      :shop-data="selectedShopData"
      @navigate="handleShopNavigate"
    />
    
    <!-- 旅游路线弹窗 -->
    <RouteListPopup 
      v-model="showRouteListPopup"
      :route-list="routeList"
      :loading="routeLoading"
      :finished="routeFinished"
      @route-click="handleRouteClick"
      @load-more="handleRouteLoadMore"
    />
    
  </div>
</template>

<script>
let  markerIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/marker.png'
let mark1 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark1.png'
let mark2 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark2.png'
let mark3 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark3.png'
let mark4 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark4.png'
let mark5 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark5.png'
let mark6 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark6.png'
let mark7 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/mark7.png'
let mark8=  require('@/assets/icon12.png')
let icon9 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon9.png'
let icon10 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon10.png'
let icon11 = 'https://lbs-nfncb.nfncb.cn/gzmap/img/icon11.png'
let lineIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/line.png'
let newsIcon = 'https://lbs-nfncb.nfncb.cn/gzmap/img/news.png'
import { addMapImageOverlay, destroyImageLayer, loadDistrictBoundary, fitBounds } from '@/utils/mapUtils'
import NavHeader from '@/components/NavHeader.vue'
import CategoryMenu from '@/components/CategoryMenu.vue'
import SearchPopup from '@/components/SearchPopup.vue'
import ShopListPopup from '@/components/ShopListPopup.vue'
import ShopDetailPopup from '@/components/ShopDetailPopup.vue'
import RouteListPopup from '@/components/RouteListPopup.vue'
import RibbonBar from '@/components/RibbonBar.vue'

export default {
  name: 'MapPage',
  components: {
    NavHeader,
    CategoryMenu,
    SearchPopup,
    ShopListPopup,
    ShopDetailPopup,
    RouteListPopup,
    RibbonBar
  },
  data() {
    return {
      center: {
        lat:  23.24499692186417,
        lng: 113.51721099999997
      },
      zoom: 10,
      initialCenter: {
        lat: 23.24499692186417,
        lng: 113.51721099999997
      },
      initialZoom: 9.068820921056885,
      markerIcon:markerIcon,
      lineIcon: lineIcon,
      newsIcon: newsIcon,
      mapInstance: null, // 地图实列
      isLocating: false,
      districtService: null,
      districtBounds: null,
      mapControl: {
        zoom: false,        // 隐藏缩放控件
        mapType: false,     // 隐藏地图类型控件
        fullscreen: false,  // 隐藏全屏控件
        scale: false,       // 隐藏比例尺控件
        rotation: false      // 隐藏旋转控件
      },
      mapOptions: {
        baseMap: {
          type: 'vector',
          features: ['base']
        },
        disableRotation: true, // 禁止地图旋转
        rotation: 0, // 设置旋转角度为0
        disablePitch: true, // 禁止地图倾斜/反转
        pitch: 0, // 设置倾斜角度为0
      },
      imageLayer: null,
      selectedNav: '特色农产品', // 默认选中第一个导航项
      shopList: [], // 商店列表数据
      geometries: [], // 点标记几何数据
      aggregationPoints: [], // 聚合点数组
      scatteredPoints: [], // 分散点数组
      offset: { x: 0, y: -20 }, // 聚合点偏移量
      selectedCategory: '', // 选中的分类
      showSearchPopup: false, // 是否显示搜索弹窗
      showShopListPopup: false, // 是否显示店铺列表弹窗（同一位置多个点位）
      showShopDetailPopup: false, // 是否显示店铺详情弹窗
      selectedShopData: {}, // 选中的店铺数据
      sameLocationShops: [], // 同一位置的点位列表
      showRouteListPopup: false, // 是否显示旅游路线弹窗
      routeList: [], // 旅游路线列表
      routeLoading: false, // 路线加载状态
      routeFinished: false, // 路线加载完成状态
    }
  },
  mounted() {
    // 禁止页面滚动，防止影响地图操作
    // this.disableScroll()
    
    // 上报页面访问
    this.addPageView()
    
    // 尝试通过 ref 获取地图实例（备用方案）
    this.$nextTick(() => {
      setTimeout(() => {
        this.tryGetMapFromRef()
      }, 2000)
    })

    // 默认加载第一个导航项的数据
    this.fetchList(this.selectedNav)
  },
  beforeDestroy() {
    // 恢复页面滚动
    this.enableScroll()
    
    // 清理图片图层
    destroyImageLayer(this.imageLayer)
    this.imageLayer = null
    
    // 清理地图实例
    if (this.mapInstance) {
      try {
        // 尝试销毁地图实例
        if (this.mapInstance.destroy && typeof this.mapInstance.destroy === 'function') {
          this.mapInstance.destroy()
        }
      } catch (e) {
        console.warn('地图销毁时出错:', e)
      }
      this.mapInstance = null
    }
    
    this.districtService = null
  },
  methods: {
    onMapReady(map) {
      this.handleMapInstance(map)
    },
    onMapInited(mapInstance) {
      // 尝试通过 getMap() 方法获取原生地图实例
      let nativeMap = mapInstance
      if (mapInstance && typeof mapInstance.getMap === 'function') {
        nativeMap = mapInstance.getMap()
      } else if (mapInstance && mapInstance.map) {
        nativeMap = mapInstance.map
      }
      
      this.handleMapInstance(nativeMap)
    },
    tryGetMapFromRef() {
      if (this.$refs.tlbsMap) {
        // 尝试多种方式获取地图实例
        let map = null
        map = this.$refs.tlbsMap.map
        if (map) {
          this.handleMapInstance(map)
        }
      }
    },
    handleMapInstance(map) {
      
      if (!map) {
        return
      }
      let nativeMap = map
      this.mapInstance = nativeMap || map
      
      // 禁止地图旋转并设置缩放级别限制
      if (this.mapInstance) {
        try {
          // 设置地图选项禁止旋转、倾斜和缩放级别
          if (typeof this.mapInstance.setOptions === 'function') {
            this.mapInstance.setOptions({
              disableRotation: true,
              rotation: 0,
              disablePitch: true,
              pitch: 0,
            })
          }
          // 禁用旋转手势
          if (typeof this.mapInstance.setRotation === 'function') {
            this.mapInstance.setRotation(0)
          }
          // 禁用倾斜手势
          if (typeof this.mapInstance.setPitch === 'function') {
            this.mapInstance.setPitch(0)
          }
          // 监听旋转事件，强制设置为0
          if (typeof this.mapInstance.on === 'function') {
            this.mapInstance.on('rotate', () => {
              if (this.mapInstance && typeof this.mapInstance.setRotation === 'function') {
                this.mapInstance.setRotation(0)
              }
            })
            // 监听倾斜事件，强制设置为0
            this.mapInstance.on('pitch', () => {
              if (this.mapInstance && typeof this.mapInstance.setPitch === 'function') {
                this.mapInstance.setPitch(0)
              }
            })
          }
        } catch (error) {
          console.warn('设置地图选项失败:', error)
        }
      }
      
      // 等待地图和service库加载完成
      setTimeout(() => {
        this.initDistrictService()
      }, 1000)
    },
    initDistrictService() {
      // 等待 TMap.service 加载完成
      if (typeof TMap !== 'undefined' && TMap.service && TMap.service.District) {
        this.loadGuangzhouDistrict()
      } else {
        // 如果service库未加载，等待加载
        let checkCount = 0
        const checkService = setInterval(() => {
          checkCount++
          if (typeof TMap !== 'undefined' && TMap.service && TMap.service.District) {
            clearInterval(checkService)
            this.loadGuangzhouDistrict()
          } else if (checkCount > 100) {
            clearInterval(checkService)
          }
        }, 100)
      }
    },
    loadGuangzhouDistrict() {
      loadDistrictBoundary(
        this.mapInstance,
        '440100',
        (bounds, shouldFitBounds) => {
          this.districtBounds = bounds
          // 添加图片贴图
          this.addMapImage()
          // 调整地图视野以完整显示区域
          if (shouldFitBounds && this.mapInstance && typeof this.mapInstance.fitBounds === 'function') {
            this.mapInstance.fitBounds(bounds)
          }
        },
        (error) => {
          // 静默处理错误
        }
      )
    },
    addMapImage() {
      this.imageLayer = addMapImageOverlay(
        this.mapInstance,
        this.districtBounds,
        null,
        this.imageLayer
      )
    },
    // 导航点击事件
    handleNavClick(category) {
      this.geometries = []
      this.shopList = []
      this.aggregationPoints = []
      this.scatteredPoints = []
      // 更新选中的导航项
      this.selectedNav = category
      // 如果不是特色农产品，清空分类选择
      if (category !== '特色农产品') {
        this.selectedCategory = ''
      }
      // 请求接口获取数据
      this.fetchList(category)
    },
    // 请求商店列表接口
    fetchList(classify, classifySecond = '') {
      if (!classify) {
        return
      }
      
      let url = `/api/classify_shop_list?classify=${classify}`
      if (classifySecond) {
        url += `&classify_second=${encodeURIComponent(classifySecond)}`
      }
      
      this.$api
        .get(url)
        .then((response) => {
          const data = response && response.data
          if (data && Array.isArray(data.data)) {
            this.shopList = data.data
            // 转换为点标记几何数据
            this.convertToGeometries(data.data)
          } else {
            this.shopList = []
            this.geometries = []
          }
        })
        .catch((error) => {
          console.warn('获取商店列表失败:', error)
          this.shopList = []
          this.geometries = []
        })
    },
    // 将商店数据转换为点标记几何数据
    convertToGeometries(shopList) {
      if (!shopList || shopList.length === 0) {
        this.geometries = []
        return
      }
      
      // 将商店数据转换为点标记几何数据格式
      this.geometries = shopList
        .filter(shop => shop.lat && shop.lng)
        .map((shop) => {
          const lat = parseFloat(shop.lat)
          const lng = parseFloat(shop.lng)
          
          // 过滤掉无效坐标
          if (isNaN(lat) || isNaN(lng) || lat < 20 || lat > 25 || lng < 110 || lng > 115) {
            return null
          }
          
          return {
            position: { lat, lng },
            properties: {
              ...shop
            }
          }
        })
        .filter(Boolean)
      
    },
    // 聚合簇变化事件
    clusterChange(scatteredPoints, aggregationPoints) {
      // 处理分散点
      this.scatteredPoints = scatteredPoints.map(item => ({
        center: item.center,
        data: item.data,
        properties: item.data.geometries && item.data.geometries[0] ? item.data.geometries[0].properties : null
      }))
      
      // 处理聚合点
      this.aggregationPoints = aggregationPoints.map(item => ({
        center: item.center,
        content: item.content,
        data: item.data
      }))
     
    },
    // 聚合点点击事件 - 直接使用 fitBounds
    domoOverlayClick(item, event) {
      // 阻止事件冒泡和默认行为
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      if (item.data && item.data.bounds) {
        this.mapInstance.fitBounds(item.data.bounds)
      }
    },
    // 分散点点击事件
    openDetail(item) {
      console.log('分散点点击事件触发', item)
      if (!this.mapInstance) {
        console.warn('地图实例不存在')
        return
      }
      
      // 获取分散点的坐标
      let lat = null
      let lng = null
      
      if (item.center) {
        // 如果 center 是对象，直接获取 lat 和 lng
        if (typeof item.center === 'object' && item.center.lat !== undefined) {
          lat = item.center.lat
          lng = item.center.lng
        } 
        // 如果 center 是 TMap.LatLng 对象，使用 getLat 和 getLng
        else if (typeof item.center.getLat === 'function') {
          lat = item.center.getLat()
          lng = item.center.getLng()
        }
      }
      
      // 如果从 center 获取失败，尝试从 properties 中获取
      if ((!lat || !lng) && item.properties) {
        // 尝试从数据中获取坐标（如果有的话）
        if (item.data && item.data.geometries && item.data.geometries[0]) {
          const geometry = item.data.geometries[0]
          if (geometry.position) {
            if (typeof geometry.position === 'object' && geometry.position.lat !== undefined) {
              lat = geometry.position.lat
              lng = geometry.position.lng
            } else if (typeof geometry.position.getLat === 'function') {
              lat = geometry.position.getLat()
              lng = geometry.position.getLng()
            }
          }
        }
      }
      
      // 构建店铺数据对象，优先从 properties 获取，如果没有完整数据则从 shopList 中查找
      let shopData = {}
      
      if (item.properties && item.properties.id) {
        // 先尝试从 shopList 中查找完整数据
        const shopId = item.properties.id
        // 点击点位时上报浏览次数
        this.addViewCount(shopId)
        const fullShopData = this.shopList.find(shop => shop.id === shopId)
        
        if (fullShopData) {
          // 如果找到了完整数据，使用完整数据
          shopData = {
            ...fullShopData,
            lat: lat ? lat.toString() : (fullShopData.lat || ''),
            lng: lng ? lng.toString() : (fullShopData.lng || '')
          }
        } else {
          // 如果找不到，使用 properties 中的数据，并补充缺失字段
          shopData = {
            ...item.properties,
            lat: lat ? lat.toString() : '',
            lng: lng ? lng.toString() : ''
          }
        }
      } else {
        // 如果 properties 为空，使用默认值
        shopData = {
          name: '未知店铺',
          lat: lat ? lat.toString() : '',
          lng: lng ? lng.toString() : ''
        }
      }
      
      console.log('店铺数据:', shopData)
      console.log('原始 item:', item)
      
      // 检查同一位置是否有多个点位（允许误差范围 0.0001 度，约11米）
      if (lat && lng) {
        const tolerance = 0.0001
        const sameLocationShops = this.shopList.filter(shop => {
          if (!shop.lat || !shop.lng) return false
          const shopLat = parseFloat(shop.lat)
          const shopLng = parseFloat(shop.lng)
          if (isNaN(shopLat) || isNaN(shopLng)) return false
          return Math.abs(shopLat - lat) < tolerance && Math.abs(shopLng - lng) < tolerance
        })
        
        console.log('同一位置的点位数量:', sameLocationShops.length)
        
        // 如果有多个点位，显示列表弹窗
        if (sameLocationShops.length > 1) {
          this.sameLocationShops = sameLocationShops
          this.showShopListPopup = true
        } else {
          // 如果只有一个，直接显示详情
          this.selectedShopData = shopData
          this.showShopDetailPopup = true
        }
        
        // 获取当前地图缩放级别
        let currentZoom = this.zoom
        if (this.mapInstance && typeof this.mapInstance.getZoom === 'function') {
          currentZoom = this.mapInstance.getZoom()
        }
        
        // 如果当前层级 > 12：会放大 0.5 级
        // 如果当前层级 < 12：会缩放到 12 级
        let targetZoom = 12
        if (currentZoom >= 12) {
          targetZoom = currentZoom + 1
        }
        
        console.log('平滑过渡到分散点位置:', lat, lng, '当前缩放级别:', currentZoom, '目标缩放级别:', targetZoom)
        this.smoothMoveToLocation(lat, lng, targetZoom)
      } else {
        // 如果无法获取坐标，直接显示详情
        this.selectedShopData = shopData
        this.showShopDetailPopup = true
        console.warn('无法获取分散点坐标', item)
      }
    },
    // 从列表中选择店铺
    handleShopFromListClick(shop) {
      console.log('从列表中选择店铺:', shop)
      // 构建完整的店铺数据
      const shopData = {
        ...shop,
        lat: shop.lat ? shop.lat.toString() : '',
        lng: shop.lng ? shop.lng.toString() : ''
      }
      // 选择列表项时上报浏览
      if (shopData.id) {
        this.addViewCount(shopData.id)
      }
      this.selectedShopData = shopData
      this.showShopDetailPopup = true
    },
    // 处理店铺导航
    handleShopNavigate(navigateData) {
      console.log('导航到店铺:', navigateData)
      if (navigateData.lat && navigateData.lng && this.mapInstance) {
        const lat = parseFloat(navigateData.lat)
        const lng = parseFloat(navigateData.lng)
        if (!isNaN(lat) && !isNaN(lng)) {
          // 平滑过渡到店铺位置
          this.smoothMoveToLocation(lat, lng, 12)
        }
      }
    },
    // 上报浏览次数
    async addViewCount(id) {
      if (!id) return
      try {
        await this.$api.get('/api/add_view', {
          params: { id }
        })
      } catch (error) {
        console.warn('add_view 接口调用失败:', error)
      }
    },
    // 上报页面访问
    async addPageView() {
      try {
        await this.$api.get('/api/add_page_view')
      } catch (error) {
        console.warn('add_page_view 接口调用失败:', error)
      }
    },
    // 根据 classify_second 获取对应的图标
    getMarkerIcon(item) {
      // 根据 selectedNav 判断使用哪个图标
      if (this.selectedNav === '都市农业') {
        return icon9
      } else if (this.selectedNav === '特色农事体验和乡村非遗活动') {
        return icon10
      } else if (this.selectedNav === '农业文化遗产') {
        return icon11
      }
      
      // 从 properties 中获取 classify_second
      const classifySecond = item.properties?.classify_second || ''
      // 根据 classify_second 映射到对应的图标
      const iconMap = {
        '绿色蔬菜': mark1,
        '精品花卉': mark2,
        '优质粮油': mark3,
        '优新水果': mark4,
        '生态畜禽': mark5,
        '现代渔业': mark6,
        '其他优品': mark7,
        // '马年年货': mark8
      }
      
      // 返回对应的图标，如果没有匹配则返回默认图标
      return iconMap[classifySecond] || markerIcon
    },
    // 获取点位名称
    getPointName(item) {
      if (item.properties && item.properties.name) {
        return item.properties.name
      }
      return '未知点位'
    },
    // 处理分类选择
    handleCategorySelect(categoryValue) {
      this.selectedCategory = categoryValue
      // 根据分类筛选数据，传递 classify_second 参数
      this.fetchList(this.selectedNav, categoryValue)
    },
    // 搜索按钮
    onSearchBtnClick() {
      this.showSearchPopup = true
    },
    // 点击搜索结果项
    handleResultClick(item) {
      console.log('点击了搜索结果:', item)
      // 同步导航分类到顶部 NavHeader
      if (item.classify) {
        this.selectedNav = item.classify
        // 如果是特色农产品，同步二级分类；否则清空二级分类
        if (item.classify === '特色农产品') {
          this.selectedCategory = item.classify_second || ''
        } else {
          this.selectedCategory = ''
        }
        // 重新拉取对应分类数据
        this.fetchList(this.selectedNav, this.selectedCategory)
      }
      // 可以跳转到详情页，或者在地图上定位
      if (item.lat && item.lng && this.mapInstance) {
        const lat = parseFloat(item.lat)
        const lng = parseFloat(item.lng)
        if (!isNaN(lat) && !isNaN(lng)) {
          // 平滑过渡到点位
          this.smoothMoveToLocation(lat, lng, 12)
        }
      }
    },
    // 平滑移动到指定位置
    smoothMoveToLocation(lat, lng, zoom = 15) {
      if (!this.mapInstance) {
        return
      }
      
      try {
        const targetLatLng = new TMap.LatLng(lat, lng)
        
        // 使用 easeTo 方法（平滑过渡到指定位置和缩放级别）
        if (typeof this.mapInstance.easeTo === 'function') {
          this.mapInstance.easeTo({
            center: targetLatLng,
            zoom: zoom,
            duration: 1000
          })
        } else {
          // 降级方案：直接设置位置
          if (typeof this.mapInstance.setCenter === 'function') {
            this.mapInstance.setCenter(targetLatLng)
          }
          if (typeof this.mapInstance.setZoom === 'function') {
            this.mapInstance.setZoom(zoom)
          }
        }
      } catch (error) {
        console.warn('平滑移动到位置失败:', error)
        // 降级方案：直接设置位置
        if (typeof this.mapInstance.setCenter === 'function') {
          this.mapInstance.setCenter(new TMap.LatLng(lat, lng))
        }
        if (typeof this.mapInstance.setZoom === 'function') {
          this.mapInstance.setZoom(zoom)
        }
      }
    },
    // 处理旅游路线
    handleRoute() {
      console.log('点击了旅游路线')
      // 显示弹窗
      this.showRouteListPopup = true
      // 如果路线列表为空，请求数据
      if (this.routeList.length === 0) {
        this.fetchLineList()
      }
    },
    // 请求旅游路线列表接口
    fetchLineList() {
      this.routeLoading = true
      const url = '/api/line_list'
      this.$api
        .get(url)
        .then((response) => {
          const data = response && response.data
          if (data && data.code === 200 && Array.isArray(data.data)) {
            console.log('获取旅游路线列表成功:', data.data)
            // 更新路线列表
            this.routeList = data.data.map(route => ({
              id: route.id,
              name: route.name || '未知路线',
              county: route.county || '未知地区',
              line_cover: route.line_cover || '',
              introduction: route.introduction || ''
            }))
            this.routeFinished = true
          } else {
            this.routeList = []
            this.routeFinished = true
          }
          this.routeLoading = false
        })
        .catch((error) => {
          console.warn('获取旅游路线列表失败:', error)
          this.routeList = []
          this.routeFinished = true
          this.routeLoading = false
        })
    },
    // 处理路线点击
    handleRouteClick(route) {
      console.log('点击了路线:', route)
    },
    // 处理路线加载更多（如果需要分页）
    handleRouteLoadMore() {
      // 目前接口没有分页，所以不需要加载更多
      this.routeLoading = false
    },
    // 处理穗农资讯
    handleNews() {
      console.log('点击了穗农资讯')
      // 这里可以添加跳转到资讯页面的逻辑
    },
    getUserLocation() {
      if (this.isLocating) return
      
      this.isLocating = true
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude
            const userLng = position.coords.longitude
            
            // 更新地图中心点（通过更新center属性，组件会自动响应）
            this.center = {
              lat: userLat,
              lng: userLng
            }
            
            // 如果地图已初始化，直接设置中心点
            if (this.mapInstance && typeof this.mapInstance.setCenter === 'function') {
              // 使用TMap API（如果可用）
              if (typeof TMap !== 'undefined') {
                this.mapInstance.setCenter(new TMap.LatLng(userLat, userLng))
              }
            }
            
            this.isLocating = false
          },
          (error) => {
            this.isLocating = false
          },
          {
            enableHighAccuracy: true, // 高精度定位
            timeout: 10000, // 超时时间
            maximumAge: 0 // 不使用缓存
          }
        )
      } else {
        this.isLocating = false
      }
    },
    // 禁止页面滚动
    disableScroll() {
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    },
    // 恢复页面滚动
    enableScroll() {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    },
    // 还原地图到初始等级
    resetMapToMaxZoom() {
      if (!this.mapInstance) {
        console.warn('地图实例不存在')
        return
      }
      
      // 还原到初始中心点和初始缩放级别
      const targetCenter = new TMap.LatLng(this.initialCenter.lat, this.initialCenter.lng)
      
      // 使用平滑过渡
      if (typeof this.mapInstance.easeTo === 'function') {
        this.mapInstance.easeTo({
          center: targetCenter,
          zoom: 9.068820921056885,
          duration: 1000
        })
      }
      this.mapInstance.setZoom(9.068820921056885)
      // 更新响应式数据
      this.center = { ...this.initialCenter }
      // this.zoom = 9.068820921056885
    }
  }
}
</script>

<style scoped>
.map-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* overflow: hidden; */
}

.map-container {
  width: 100%;
  height: 100vh;
  height: calc(100vh - env(safe-area-inset-bottom)); /* 适配iPhone X等安全区域 */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* overflow: hidden; */
  touch-action: none; /* 禁止默认触摸行为 */
  -webkit-overflow-scrolling: touch;
}

.map-wrapper {
  width: 100%;
  height: 100%;
}

/* 聚合点样式 */
.polymerization {
  width: 90px;
  height: 90px;
  background-image: url('https://lbs-nfncb.nfncb.cn/gzmap/img/markerbig.png');
  /* width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(138.59deg, rgba(255, 118, 118, 0.9) 11.12%, rgba(255, 61, 61, 0.9) 75.89%); */
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
  position: absolute;
  top: -40px;
  left: -50px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
}

/* 聚合点数量文字 */
.polymerization .cluster-count {
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 20px;
  padding-bottom: 16px;
  font-weight: bold;
}

/* 分散点样式 */
.point-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: -18px;
  left: -16px;
}

.point-logo {
  width: 48px;
  height: 51px;
  position: relative;
  cursor: pointer;
  z-index: 1;
}

.point-logo img {
  width: 48px;
  height: 51px;
  display: block;
  position: relative;
  object-fit: contain;
}

.point-logo.point-disabled img {
  filter: grayscale(100%);
}

.point-name {
  position: relative;
  margin-top: 2px;
  padding: 4px 8px;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  border-radius: 4px;
  pointer-events: none;
  z-index: 2;
  text-align: center;
  line-height: 1.4;
}

/* 移动端优化 */
@media screen and (max-width: 768px) {
  .map-container {
    height: 100vh;
    height: calc(100vh - env(safe-area-inset-bottom));
  }
}

/* 防止iOS Safari底部工具栏遮挡 */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .map-container {
    padding-bottom: env(safe-area-inset-bottom);
  }
}

/* 底部搜索和功能按钮 */
.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #fff;
  padding: 16px 0;
  border-radius: 30px 30px 0 0;
}

.search-bar {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  margin: 8px 16px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 28px;
  color: #999;
  padding: 8px 12px;
  background: transparent;
  cursor: pointer;
}

.search-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  background: url("https://lbs-nfncb.nfncb.cn/gzmap/img/search.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.search-btn:active {
  transform: scale(0.95);
}

.search-btn img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.action-buttons {
  display: flex;
  gap: 16px;
  padding: 12px 16px 24px;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
}

.action-btn {
  flex: 1;
  height: 82px;
  cursor: pointer;
  transition: transform 0.2s;
  object-fit: contain;
}

.action-btn:active {
  transform: scale(0.98);
}

/* 搜索弹窗样式 */
.search-popup {
  height: 100%;
  width: 10rem;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.search-header-left {
  width: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-header-title {
  flex: 1;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  color: #333;
}

.search-header-right {
  width: 40px;
}

.search-popup-bar {
  padding: 16px 20px;
  background-color: #fff;
}

.search-bar-inner {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 50px;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  margin: 8px 16px;
}

.search-input-inner {
  flex: 1;
  border: none;
  outline: none;
  font-size: 28px;
  color: #333;
  padding: 8px 12px;
  background: transparent;
}

.search-input-inner::placeholder {
  color: #999;
}

.search-btn-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  background: url("https://lbs-nfncb.nfncb.cn/gzmap/img/search.png") no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.search-btn-inner:active {
  transform: scale(0.95);
}


.search-results {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.search-result-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-result-item:active {
  background-color: #f5f5f5;
}

.search-result-item:last-child {
  border-bottom: none;
}

.result-icon {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.result-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-name {
  font-size: 30px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
}

.result-desc {
  font-size: 24px;
  color: #999;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.nhj-img{
  width: 200px;
  height: 185px;
  position: absolute;
  bottom: 130px;
  right: 0;
  z-index: 1000;
}

/* 还原地图按钮 */
.reset-map-btn {
  position: absolute;
  top: 170px;
  left: 20px;
  width: 60px;
  height: 60px;
  background: url("https://lbs-nfncb.nfncb.cn/gzmap/img/fy.png");
  background-size: 100% 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 200;
  cursor: pointer;
  transition: all 0.3s;
}

.reset-map-btn:active {
  transform: scale(0.95);
  background-color: rgba(255, 255, 255, 1);
}

.reset-icon {
  font-size: 32px;
  color: #004e44;
  line-height: 1;
}
</style>
